import { IState } from 'shared/store';

export const getNewbuildingHouseId = (state: IState): number | undefined => {
  return state.offerData.offer.newbuilding.house?.id;
};
